import { locale_es } from "./translation.es";

export const locale_es_ES = {
    "lang": "es-ES",
    "data": locale_es.data
}
